export default __webpack_public_path__ + "static/8-56f9bc9ff87e430335ae5588e4b5df0a.png";